import React, { useState } from 'react'
import './HeadlinesBanner.css'
import { adjustBannerIndex } from '../utils/headlines'
import moment, { Moment } from 'moment'
import { NewHabitType } from './TargetScores'
import { habitTypeNameMap } from '../utils/constants'

export interface Headline {
  playerFirstName: string
  belongsToFoundingMember: boolean
  habitType: NewHabitType
  createdAt: Moment
}

export interface PlacedHeadline extends Headline {
  bannerIndex: number
}

interface HeadlinesBannerProps {
  headlines: Headline[]
}

const HeadlineFlyer: React.FC<{ headline: PlacedHeadline }> = ({ headline }) => {
  const minutesAgo = moment().diff(headline.createdAt, 'minutes');
  const formattedTime = moment.duration(minutesAgo, 'minutes').humanize();
  const imagePath = headline.belongsToFoundingMember ? "./founderAstro.png" : "./astro.png"
  
  return (
    <div className="HeadlineFlyer">
      <img src={imagePath} width="40px" alt="Headline" className="HeadlineFlyer--image" />
      <div>
        <div><strong>{headline.playerFirstName}</strong></div>
        <div className='HeadlineFlyer--text'>hit their {habitTypeNameMap[headline.habitType]} target</div>
        <div className='HeadlineFlyer--timestamp'>{`${formattedTime} ago`}</div>
      </div>
    </div>
  );
};

const HeadlinesBanner: React.FC<HeadlinesBannerProps> = ({ headlines }) => {
  const [placedHeadlines, setPlacedHeadlines] = useState<PlacedHeadline[]>(adjustBannerIndex(headlines))
  return (
    <div className="HeadlinesBanner" style={{ marginTop: 20}}>
      <div
        className="HeadlinesBanner--background"
        style={{ backgroundImage: 'url("spaceBackground.png")' }}>
      </div>

      {placedHeadlines.map((headline, index) => {
        const verticalOffset = Math.random() * 90

        return (
          <div
            key={index}
            className="HeadlineFlyerWrapper"
            style={{
              right: `${headline.bannerIndex}px`,
              top: `${verticalOffset}px`,
            }}
          >
            <HeadlineFlyer headline={headline} />
          </div>
        )
      })}
    </div>
  )
}

export { HeadlinesBanner, HeadlineFlyer }